import {
  List,
  ListItem,
  Typography,
  ListItemIcon,
  Card,
  CardActionArea,
  CardContent
} from '@material-ui/core';
import { DSScreen, DSScreenMenuCell, DSScreenMenuCellItem } from 'kiolyn-api';
import React, { FC, Fragment } from 'react';
import { isNullOrUndefined } from 'util';
import { makeStyles } from '@material-ui/core/styles';
import Image from 'material-ui-image';
import { Fastfood } from '@material-ui/icons';
import CurrencyFormat from '../Core/CurrencyFormat/CurrencyFormat';

const useStyles = makeStyles(theme => ({
  card: {
    width: '30em',
    margin: 'auto',
    position: 'relative',
    alignContent: 'center'
  },
  noImage: {
    color: theme.palette.text.disabled,
    paddingTop: 'calc(20%)',
    fontSize: 100
  },
  paddingImage: {
    padding: 1
  },
  cardActions: {
    justifyContent: 'center'
  },
  price: {
    minWidth: '4em',
    textAlign: 'right'
  }
}));

interface ImageCellProps {
  screen: DSScreen;
  cell: DSScreenMenuCell;
}

const ImageCell: FC<ImageCellProps> = ({ screen, cell }: ImageCellProps) => {
  const classes = useStyles();
  const items: DSScreenMenuCellItem[] = isNullOrUndefined(cell.items)
    ? []
    : cell.items;
  const denseStyle = {
    paddingTop: 0,
    paddingBottom: 0
  };
  return (
    <Fragment>
      <Typography
        key="category"
        style={{
          fontSize: screen.category_font_size + 'px',
          color: screen.category_color
        }}
      >
        {cell.name}
      </Typography>
      <List key="items" dense>
        {items.map((item, index) => (
          <ListItem
            key={index}
            style={screen.dense ? denseStyle : {}}
            className={classes.paddingImage}
          >
            {(item.show_hide_on_tv === undefined ||
              item.show_hide_on_tv === null ||
              item.show_hide_on_tv) &&
              !isNullOrUndefined(item.imageURL) && (
                <ListItemIcon>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography
                        variant="body1"
                        className={classes.price}
                        style={{
                          fontSize: screen.item_font_size + 'px',
                          color: screen.item_color
                        }}
                      >
                        <CurrencyFormat amount={item.price} />
                      </Typography>
                    </CardContent>
                    <CardActionArea>
                      <Image
                        src={item.imageURL}
                        aspectRatio={16 / 9}
                        imageStyle={{
                          objectFit: 'stretch',
                          height: '20em',
                          position: 'inherit'
                        }}
                        loading={<Fastfood className={classes.noImage} />}
                        style={{ paddingTop: 'calc(0%)' }}
                      />
                    </CardActionArea>
                    <CardContent
                      style={{
                        paddingTop:
                          item.imageURL === '' ? 'calc(25%)' : 'calc(0%)'
                      }}
                    >
                      <Typography
                        variant="body1"
                        style={{
                          fontSize: screen.item_font_size + 'px',
                          color: screen.item_color
                        }}
                      >
                        {item.name}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{
                          fontSize: screen.item_font_size + 'px',
                          color: screen.item_color
                        }}
                      >
                        {cell.show_name_2 &&
                          !isNullOrUndefined(item.name2) &&
                          '(' + item.name2 + ')'}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: screen.description_font_size + 'px',
                          color: screen.description_color
                        }}
                      >
                        {item.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </ListItemIcon>
              )}
          </ListItem>
        ))}
      </List>
    </Fragment>
  );
};

export default ImageCell;
